module.exports = __webpack_public_path__ + "img/module6_6.84e991c3.png";